import {
  Component, OnInit, ViewEncapsulation,
  ChangeDetectionStrategy, Input, Output, EventEmitter
} from '@angular/core';

import { TagType, TagTypeIcon, TagTypeLabel } from '@ux/components/member-rate-tag/entities/tag-type';
import { HotelFilterApplier, HotelFilterTypes } from '@shared/hotel-itinerary/hotel-filters';
import { isTagTypeisPrime, isTagTypeisRappicard } from '@app/mappers/filters.mapper';
import { HotelFilterVm } from '@shared/magic-filter-bar/entities/filter-types';
import { CheckboxFilter } from '@shared/filters/entities/fetch-filters.response';
import { CheckboxAlign } from '@design-system/components/organisms/checkbox/entities/checkbox.types';

@Component({
  selector: 'app-exclusive-offer-filter',
  templateUrl: './exclusive-offer-filter.component.html',
  styleUrls: ['./exclusive-offer-filter.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ExclusiveOfferFilterComponent implements OnInit {

  @Input() exclusiveOffer: boolean;
  @Input() index: number = -1;
  @Input() isMobile: boolean = false;
  @Input() isOpenBox: boolean;
  @Input() hasRappiCard: boolean;
  @Input() isPrime: boolean;
  @Input() filterExclusive: HotelFilterVm;
  @Input() source: string;

  @Output() filter: EventEmitter<HotelFilterApplier> = new EventEmitter<HotelFilterApplier>();

  constructor() { }

  ngOnInit(): void {
    if (!this.isOpenBox) {
      this.isOpenBox = this.index ===
        0;
    }
  }

  get checkboxAlign(): CheckboxAlign {
    return this.isMobile ? CheckboxAlign.Right : CheckboxAlign.Left;
  }

  get tagTypeisPrime(): boolean {
    return isTagTypeisPrime(this.source, this.isPrime);
  }

  get tagTypeisRappicard(): boolean {
    return isTagTypeisRappicard(this.source, this.hasRappiCard);
  }

  get showOfferExclusiveFilter(): boolean {
    return (this.isPrime || this.hasRappiCard) && 
           (this.filterExclusive.value as CheckboxFilter[]).some(value => value.Count > 0 );
  }

  get total(): string {
    return this.filterExclusive?.value[0]?.Count;
  }

  get offerLabel(): string {
    return this.tagTypeisPrime ? TagTypeLabel[TagType.Prime] : TagTypeLabel[TagType.RappiCard];
  }

  get offerIcon(): string {
    return this.tagTypeisPrime ? TagTypeIcon[TagType.Prime] : TagTypeIcon[TagType.RappiCard];
  }

  public toggleCheckboxOptions(): void {
    this.isOpenBox = !this.isOpenBox;
  }

  public select(): void {
    this.filter.emit({ type: <HotelFilterTypes>this.filterExclusive?.type?.toString(), value: !this.exclusiveOffer });
  }

  public uniqueId(): string {
    return 'check-exclusive-offer';
  }

}
